import { render } from "./NormalCalculator.vue?vue&type=template&id=207644c4"
import script from "./NormalCalculator.vue?vue&type=script&lang=js"
export * from "./NormalCalculator.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__